import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useGtm } from 'hooks/useGtm';
import "Assets/css/mbti.css";

type QType = string;

interface Question {
  img:string,
  title: string;
  axis: string; // canonical axis like 'EI','SN','TF','JP'
  A: string;
  B: string;
  Aletter: string; // letter to increment when A chosen (e.g. 'E' or 'I')
  Bletter: string; // letter to increment when B chosen
}

interface ResultItem {
  animal: string;
  explain: string;
  explain2: string;
  img: string;
  card: string;
  mbtiResult: string;
  resultNumber: string;

}

const QUESTIONS: Question[] = [
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q1.png'}`, title: '당신이 더 끌리는\n베어브릭 사이즈는?', axis: 'EI', A: '한 손에 딱 들어오는 100% 베어브릭', B: '공간을 채우는 존재감 있는 1000% 베어브릭', Aletter: 'I', Bletter: 'E' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q2.png'}`, title: '베어브릭을 봤을 때\n먼저 눈에 들어오는 건?', axis: 'TF', A: '무난하지만 예쁜 디자인', B: '취향이 확 느껴지는 디자인', Aletter: 'F', Bletter: 'T' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q3.png'}`, title: '더 마음이 가는\n베어브릭 타입은?', axis: 'JP', A: '보면 마음이 편해지는 베어브릭', B: '보면 갖고 싶다는 욕심이 드는 베어브릭', Aletter: 'P', Bletter: 'J' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q4.png'}`, title: '베어브릭을 둔다면\n어디가 좋을까?', axis: 'SN', A: '어떤 디자인일지 보는 재미', B: '얼마나 희귀한지 아는 재미', Aletter: 'N', Bletter: 'S' },
];

const QUESTIONS_EN: Question[] = [
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q1_en.png'}`, title: 'Which BE@RBRICK size\nappeal to you more?', axis: 'EI', A: '100% (Fits in your hand)', B: '1000% (Bold presence)', Aletter: 'I', Bletter: 'E' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q2_en.png'}`, title: 'What catches your eye first\nwhen looking at a BE@RBRICK?', axis: 'TF', A: 'Simple and beautiful', B: 'Bold and shows your taste', Aletter: 'F', Bletter: 'T' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q3_en.png'}`, title: 'Which type of BE@RBRICK\ndo you prefer?', axis: 'JP', A: 'Calm and comforting', B: 'Instant Must-have', Aletter: 'P', Bletter: 'J' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q4_en.png'}`, title: 'Where would you like to\ndisplay a BE@RBRICK?', axis: 'SN', A: 'Discovering the design', B: 'Finding out how rare it is', Aletter: 'N', Bletter: 'S' },
];
const QUESTIONS_ZH: Question[] = [
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q1_zh.png'}`, title: 'Which BE@RBRICK size\nappeal to you more?', axis: 'EI', A: '一隻手剛好握得住的 100% BE@RBRICK', B: '為空間帶來強烈存在感的 1000% BE@RBRICK', Aletter: 'I', Bletter: 'E' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q2_zh.png'}`, title: 'What catches your eye first\nwhen looking at a BE@RBRICK?', axis: 'TF', A: '簡約卻好看的設計', B: '一眼就能看出個人品味的設計', Aletter: 'F', Bletter: 'T' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q3_zh.png'}`, title: 'Which type of BE@RBRICK\ndo you prefer?', axis: 'JP', A: '看著就讓人感到放鬆的 BE@RBRICK', B: '看了就讓人忍不住想收藏的 BE@RBRICK', Aletter: 'P', Bletter: 'J' },
  { img: `${process.env.PUBLIC_URL + '/images/content/mbti/question/q4_zh.png'}`, title: 'Where would you like to\ndisplay a BE@RBRICK?', axis: 'SN', A: '期待看看會是什麼設計的樂趣', B: '了解它有多稀有的樂趣', Aletter: 'N', Bletter: 'S' },
];


const RESULTS: Record<string, ResultItem> = {
  ENTJ: { animal: '자기 기준의 정의', explain: '선악을 스스로 판단하며 움직인다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card01.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_entj.png'}`, mbtiResult: 'ENTJ', resultNumber: '01' },
  INTP: { animal: '쿨한 착각', explain: '과시 속에 모순을 품고 있다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card02.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_intp.png'}`, mbtiResult: 'INTP', resultNumber: '02' },
  INFP: { animal: '방랑하는 미학', explain: '의미를 찾아 떠도는 예술가.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card03.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_infp.png'}`, mbtiResult: 'INFP', resultNumber: '03' },
  INFJ: { animal: '망상의 폭탄', explain: '상상력으로 세상을 상대한다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card04.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_infj.png'}`, mbtiResult: 'INFJ', resultNumber: '04' },
  ISTJ: { animal: '가면의 시선', explain: '거리 두기로 자신을 지킨다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card05.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_istj.png'}`, mbtiResult: 'ISTJ', resultNumber: '05' },
  ESTJ: { animal: '명령과 우연', explain: '성능은 선택에 따라 달라진다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card06.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_estj.png'}`, mbtiResult: 'ESTJ', resultNumber: '06' },
  ESFJ: { animal: '대중의 취향', explain: '안정적인 완성도를 지녔다.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card07.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_esfj.png'}`, mbtiResult:'ESFJ', resultNumber:'07'},
  ESTP: { animal: '인생은 베팅', explain: '위험 속에서 즐거움을 찾는다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card08.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_estp.png'}`, mbtiResult: 'ESTP', resultNumber: '08' },
  ISFP: { animal: '계속되는 여행', explain: '떠나며 스스로를 시험한다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card09.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_isfp.png'}`, mbtiResult: 'ISFP', resultNumber: '09' },
  INTJ: { animal: '고독한 설계자', explain: '자신만의 방향으로 세계를 계산하며 나아간다.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card10.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_intj.png'}`, mbtiResult: 'INTJ', resultNumber: '10' },
  ENTP: { animal: '전설을 좇는 자', explain: '운과 센스를 믿는다.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card11.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_entp.png'}`, mbtiResult:'ENTP', resultNumber:'11'},
  ESFP: { animal: '모호한 사랑', explain: '정답 없는 관계를 받아들인다.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card12.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_esfp.png'}`, mbtiResult:'ESFP', resultNumber:'12'},
  ISTP: { animal: '은폐된 쿨함', explain: '오해마저 개성으로 삼는다.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card13.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_istp.png'}`, mbtiResult:'ISTP', resultNumber:'13'},
  ENFJ: { animal: '성찰하는 병기', explain: '조종자에 따라 달라진다.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card14.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_enfj.png'}`, mbtiResult:'ENFJ', resultNumber:'14'},
  ISFJ: { animal: '멈추지 않는 질주', explain: '목표를 품고 끝없이 달린다.', explain2:'', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card15.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_isfj.png'}`, mbtiResult:'ISFJ', resultNumber:'15'},
  ENFP: { animal : "사랑의 폭주", explain : "사랑을 믿고 온몸으로 돌진한다.", explain2 : "", card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card16.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_enfp.png'}`, mbtiResult:'ENFP', resultNumber:'16'}
};

const RESULTS_EN: Record<string, ResultItem> = {
  ENTJ: { animal: 'Self-Defined Justice', explain: 'Moves forward by own judgment of right and wrong.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card01_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_entj.png'}`, mbtiResult: 'ENTJ', resultNumber: '01' },
  INTP: { animal: 'Cool Contradiction', explain: 'Contains contradictions within self-promotion.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card02_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_intp.png'}`, mbtiResult: 'INTP', resultNumber: '02' },
  INFP: { animal: 'Wandering Aesthete', explain: 'An artist wandering in search of meaning.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card03_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_infp.png'}`, mbtiResult: 'INFP', resultNumber: '03' },
  INFJ: { animal: 'Imagination Bomb', explain: 'Confronts the world with imagination.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card04_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_infj.png'}`, mbtiResult: 'INFJ', resultNumber: '04' },
  ISTJ: { animal: 'Mask of Distance', explain: 'Protects oneself through distancing.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card05_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_istj.png'}`, mbtiResult: 'ISTJ', resultNumber: '05' },
  ESTJ: { animal: 'Command and Chance', explain: 'Performance varies with choices made.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card06_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_estj.png'}`, mbtiResult: 'ESTJ', resultNumber: '06' },
  ESFJ: { animal: 'Taste of the Masses', explain: 'Possesses stable completeness.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card07_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_esfj.png'}`, mbtiResult:'ESFJ', resultNumber:'07'},
  ESTP: { animal: 'Life is a Bet', explain: 'Finds joy in taking risks.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card08_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_estp.png'}`, mbtiResult: 'ESTP', resultNumber: '08' },
  ISFP: { animal: 'Endless Journey', explain: 'Tests oneself by departing.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card09_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_isfp.png'}`, mbtiResult: 'ISFP', resultNumber: '09' },
  INTJ: { animal: 'Solitary Designer', explain: 'Calculates the world in your own way and moves forward.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card10_en.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_intj.png'}`, mbtiResult: 'INTJ', resultNumber: '10' },
  ENTP: { animal: 'Legend Pursuer', explain: 'Believes in luck and sense.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card11_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_entp.png'}`, mbtiResult:'ENTP', resultNumber:'11'},
  ESFP: { animal: 'Ambiguous Love', explain: 'Accepts relationships without answers.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card12_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_esfp.png'}`, mbtiResult:'ESFP', resultNumber:'12'},
  ISTP: { animal: 'Hidden Coolness', explain: 'Takes even misunderstanding as individuality.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card13_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_istp.png'}`, mbtiResult:'ISTP', resultNumber:'13'},
  ENFJ: { animal: 'Reflective Weapon', explain: 'Varies depending on the controller.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card14_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_enfj.png'}`, mbtiResult:'ENFJ', resultNumber:'14'},
  ISFJ: { animal: 'Endless Sprint', explain: 'Runs ceaselessly toward goals.', explain2:'', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card15_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_isfj.png'}`, mbtiResult:'ISFJ', resultNumber:'15'},
  ENFP: { animal: 'Love\'s Rampage', explain: 'Believes in love and charges with full force.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card16_en.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_enfp.png'}`, mbtiResult:'ENFP', resultNumber:'16'}
};
const RESULTS_ZH: Record<string, ResultItem> = {
   ENTJ: { animal: 'Self-Defined Justice', explain: 'Moves forward by own judgment of right and wrong.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card01_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_entj.png'}`, mbtiResult: 'ENTJ', resultNumber: '01' },
  INTP: { animal: 'Cool Contradiction', explain: 'Contains contradictions within self-promotion.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card02_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_intp.png'}`, mbtiResult: 'INTP', resultNumber: '02' },
  INFP: { animal: 'Wandering Aesthete', explain: 'An artist wandering in search of meaning.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card03_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_infp.png'}`, mbtiResult: 'INFP', resultNumber: '03' },
  INFJ: { animal: 'Imagination Bomb', explain: 'Confronts the world with imagination.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card04_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_infj.png'}`, mbtiResult: 'INFJ', resultNumber: '04' },
  ISTJ: { animal: 'Mask of Distance', explain: 'Protects oneself through distancing.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card05_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_istj.png'}`, mbtiResult: 'ISTJ', resultNumber: '05' },
  ESTJ: { animal: 'Command and Chance', explain: 'Performance varies with choices made.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card06_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_estj.png'}`, mbtiResult: 'ESTJ', resultNumber: '06' },
  ESFJ: { animal: 'Taste of the Masses', explain: 'Possesses stable completeness.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card07_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_esfj.png'}`, mbtiResult:'ESFJ', resultNumber:'07'},
  ESTP: { animal: 'Life is a Bet', explain: 'Finds joy in taking risks.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card08_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_estp.png'}`, mbtiResult: 'ESTP', resultNumber: '08' },
  ISFP: { animal: 'Endless Journey', explain: 'Tests oneself by departing.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card09_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_isfp.png'}`, mbtiResult: 'ISFP', resultNumber: '09' },
  INTJ: { animal: 'Solitary Designer', explain: 'Calculates the world in your own way and moves forward.', explain2: '', card: `${process.env.PUBLIC_URL + '/images/content/mbti/result/card10_zh.png'}`, img: `${process.env.PUBLIC_URL + '/images/content/mbti/result_intj.png'}`, mbtiResult: 'INTJ', resultNumber: '10' },
  ENTP: { animal: 'Legend Pursuer', explain: 'Believes in luck and sense.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card11_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_entp.png'}`, mbtiResult:'ENTP', resultNumber:'11'},
  ESFP: { animal: 'Ambiguous Love', explain: 'Accepts relationships without answers.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card12_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_esfp.png'}`, mbtiResult:'ESFP', resultNumber:'12'},
  ISTP: { animal: 'Hidden Coolness', explain: 'Takes even misunderstanding as individuality.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card13_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_istp.png'}`, mbtiResult:'ISTP', resultNumber:'13'},
  ENFJ: { animal: 'Reflective Weapon', explain: 'Varies depending on the controller.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card14_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_enfj.png'}`, mbtiResult:'ENFJ', resultNumber:'14'},
  ISFJ: { animal: 'Endless Sprint', explain: 'Runs ceaselessly toward goals.', explain2:'', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card15_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_isfj.png'}`, mbtiResult:'ISFJ', resultNumber:'15'},
  ENFP: { animal: 'Love\'s Rampage', explain: 'Believes in love and charges with full force.', explain2: '', card:`${process.env.PUBLIC_URL + '/images/content/mbti/result/card16_zh.png'}`, img:`${process.env.PUBLIC_URL + '/images/content/mbti/result_enfp.png'}`, mbtiResult:'ENFP', resultNumber:'16'}
};
const initialScores: Record<string, number> = { E: 0, I: 0, S: 0, N: 0, T: 0, F: 0, J: 0, P: 0 };
type SoundKey = 'complete' | 'dragClick' | 'click' | 'rightMenuSelect'|'bearbrickSearch';

export default function MbtiQuiz(): JSX.Element {
  const [started, setStarted] = useState(false);
  const [index, setIndex] = useState(0); // number answered
  const [scores, setScores] = useState<Record<string, number>>(initialScores);
  const [showResult, setShowResult] = useState(false);
  const [thumbIndex, setThumbIndex] = useState<number>(1);
  const [forcedResult, setForcedResult] = useState<string | null>(null);
  const [showWaiting, setShowWaiting] = useState(false);
  const [ellipsis, setEllipsis] = useState('');
  const [toastMsg, setToastMsg] = useState<string | null>(null);
  const [lang, setLang] = useState<'ko' | 'en'| 'zh'>('ko');
  const toastTimeoutRef = useRef<number | null>(null);
  const waitingTimeoutRef = useRef<number | null>(null);
  const soundRefs = useRef<Record<SoundKey, HTMLAudioElement | null>>({
    complete: null,
    dragClick: null,
    click: null,
    rightMenuSelect: null,
    bearbrickSearch: null,
  });

  const total = QUESTIONS.length;
  const { push: gtmPush } = useGtm();

  // Get language from URL parameter
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const langParam = params.get('lang');
      if (langParam === 'en') {
        setLang('en');
      } else if (langParam === 'zh') {
        setLang('zh');

      } else {
        setLang('ko');
      }
    } catch (e) {
      setLang('ko');
    }
  }, []);

  // Select questions and results based on language
  const currentQuestions = lang === 'en' ? QUESTIONS_EN : lang === 'zh' ? QUESTIONS_ZH : QUESTIONS;
  const currentResults = lang === 'en' ? RESULTS_EN : lang === 'zh' ? RESULTS_ZH : RESULTS;

  const playButtonSound = (key: SoundKey = 'click') => {
    const audio = soundRefs.current[key];
    if (audio) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }
  };

  useEffect(() => {
    // start 화면 또는 waiting 상태에서 썸네일 자동 슬라이드 실행
    if (started && !showWaiting) return;
    const id = setInterval(() => {
      setThumbIndex(prev => (prev % 12) + 1);
    }, 500);
    return () => clearInterval(id);
  }, [started, showWaiting]);

  const handleStart = useCallback(() => {
    playButtonSound();
    setStarted(true);
    setIndex(0);
    setScores(initialScores);
    setShowResult(false);
  }, []);

  const handleRestart = useCallback(() => {
    setStarted(false);
    setIndex(0);
    setScores(initialScores);
    setShowResult(false);
    setForcedResult(null);
    setShowWaiting(false);
    if (waitingTimeoutRef.current) {
      window.clearTimeout(waitingTimeoutRef.current);
      waitingTimeoutRef.current = null;
    }
    // remove resultNumber param from URL when restarting, keep lang param
    try {
      const params = new URLSearchParams(window.location.search);
      params.delete('resultNumber');
      const newSearch = params.toString() ? '?' + params.toString() : '';
      const newUrl = window.location.pathname + newSearch + window.location.hash;
      window.history.replaceState(null, '', newUrl);
    } catch (e) {
      // ignore
    }
    // ensure page is at top when restarting
    try {
      window.scrollTo({ top: 0, behavior: 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    gtmPush('bb4meRestart', {
    });

  }, []);

  const handleAnswer = useCallback((choice: 'A' | 'B') => {
    playButtonSound();
    if (showResult || showWaiting) return;
    const q = currentQuestions[index];
    const letter = choice === 'A' ? q.Aletter : q.Bletter;
    setScores(prev => ({ ...prev, [letter]: (prev[letter] || 0) + 1 }));
    const next = index + 1;
    if (next >= total) {
      setIndex(total);
      setShowWaiting(true);
    } else {
      setIndex(next);
    }
  }, [index, showResult, showWaiting, total, currentQuestions]);

  useEffect(() => {
    if (!showWaiting) return;
    waitingTimeoutRef.current = window.setTimeout(() => {
      playButtonSound("complete");
      setShowResult(true);
      setShowWaiting(false);
      waitingTimeoutRef.current = null;
    }, 2000);
    return () => {
      if (waitingTimeoutRef.current) {
        window.clearTimeout(waitingTimeoutRef.current);
        waitingTimeoutRef.current = null;
      }
    };
  }, [showWaiting]);

  // animate ellipsis when waiting ("", ".", "..", "...")
  useEffect(() => {
     if (!showWaiting) {
       setEllipsis('');
       return;
     }
    let i = 0;
    playButtonSound('bearbrickSearch')
    const id = window.setInterval(() => {
      setEllipsis('.'.repeat(i % 4));
      i += 1;
    }, 400);
    return () => {
      window.clearInterval(id);
      setEllipsis('');
    };
  }, [showWaiting]);
  const handleCafe = useCallback(async() => {
    gtmPush('bb4meCafe', {});
    window.open('https://cafe.naver.com/bearbrickheroes', '_blank');
  }, []);
  const handleDiscord= useCallback(async() => {
    gtmPush('bb4meDiscord', {});
    window.open('https://discord.gg/H6aeYKyAa3', '_blank');
  }, []);
  const handleShare = useCallback(async () => {
    try {
      const key = computeMbti();
      const rn = currentResults[key]?.resultNumber || key;
      const url = window.location.origin + window.location.pathname + '?resultNumber=' + encodeURIComponent(rn) + window.location.hash;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      // show toast
      setToastMsg(lang === 'en' ? 'Result URL copied to clipboard.' :lang === 'zh'? '結果 URL已複製到剪貼板。': '결과 URL이 클립보드에 복사되었습니다.');
    } catch (e) {
      setToastMsg(lang === 'en' || lang === 'zh' ? 'URL copy failed.' : 'URL 복사에 실패했습니다.');
    }
    gtmPush('bb4meShare', {
    });
  }, [scores, forcedResult, lang, currentResults]);

  const handleDownload = useCallback(async () => {
    try {
      const key = computeMbti();
      const imgUrl = currentResults[key]?.img;
      if (!imgUrl) {
        setToastMsg(lang === 'en' || lang === 'zh' ? 'No image available for download.' : '다운로드할 이미지가 없습니다.');
        return;
      }
      const response = await fetch(imgUrl, { mode: 'cors' });
      if (!response.ok) throw new Error(lang === 'en' || lang === 'zh' ? 'Image loading failed' : '이미지 로드 실패');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      const rn = currentResults[key]?.resultNumber || key;
      a.href = url;
      a.download = `bb4me_result_${rn}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setToastMsg(lang === 'en' ? 'Image download started.' : lang === 'zh'?'圖片下載已開始。': '이미지 다운로드가 시작되었습니다.');
    } catch (e) {
      setToastMsg(lang === 'en' || lang === 'zh' ? 'Image download failed.' : '이미지 다운로드에 실패했습니다.');
    }
    gtmPush('bb4meImgDownload', {
    });
  }, [scores, forcedResult, lang, currentResults]);

  useEffect(() => {
    if (!toastMsg) return;
    // clear previous timeout
    if (toastTimeoutRef.current) {
      window.clearTimeout(toastTimeoutRef.current);
    }
    toastTimeoutRef.current = window.setTimeout(() => {
      setToastMsg(null);
      toastTimeoutRef.current = null;
    }, 2500);
    return () => {
      if (toastTimeoutRef.current) {
        window.clearTimeout(toastTimeoutRef.current);
        toastTimeoutRef.current = null;
      }
    };
  }, [toastMsg]);

  const computeMbti = (): string => {
    if (forcedResult) return forcedResult;
    const e = (scores.E || 0) >= (scores.I || 0) ? 'E' : 'I';
    const s = (scores.S || 0) >= (scores.N || 0) ? 'S' : 'N';
    const t = (scores.T || 0) >= (scores.F || 0) ? 'T' : 'F';
    const j = (scores.J || 0) >= (scores.P || 0) ? 'J' : 'P';
    return `${e}${s}${t}${j}`;
  };

  useEffect(() => {
    // If query contains referrer=preregister, immediately start quiz
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('referrer');
      if (ref === 'preregister') {
        setStarted(true);
        setIndex(0);
        setScores(initialScores);
        setShowResult(false);
      }
      // If `resultNumber` param is present, show the corresponding result immediately.
      const rn = params.get('resultNumber');
      if (!rn) return;
      const keys = Object.keys(RESULTS);
      // allow numeric (1-based index) like 01,1,02 etc.
      if (/^\d{1,2}$/.test(rn)) {
        const idx = parseInt(rn, 10) - 1;
        if (idx >= 0 && idx < keys.length) {
          setForcedResult(keys[idx]);
          setStarted(true);
          setShowResult(true);
          setIndex(total);
          return;
        }
      }
      // allow MBTI code directly e.g. ENFP
      if (/^[A-Za-z]{4}$/.test(rn)) {
        const key = rn.toUpperCase();
        if (RESULTS[key]) {
          setForcedResult(key);
          setStarted(true);
          setShowResult(true);
          setIndex(total);
        }
      }
    } catch (e) {
      // ignore URL parsing errors
    }
  }, []);

  useEffect(() => {
    // Whenever the UI switches to started or result view, ensure page is scrolled to top
    if (started || showResult) {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        // fallback for older browsers
        window.scrollTo(0, 0);
      }
    }
  }, [started, showResult]);

  const progressPercent = Math.round((index / total) * 100);

  return (
    <div className="mbti-quiz container py-4">
            <div className="background">
                <img src="/images/preregister/brbrFormBg.jpg" alt=""/>
            </div>

            {toastMsg && (
              <div className="mbti-toast" role="status" aria-live="polite">
                {toastMsg}
              </div>
            )}

            {!started && (
                <article className="start text-center">
                    <h1 className='pageTitl'>{lang === 'en' ? 'Find Your BE@RBRICK' : lang === 'zh'? '找到你的 BE@RBRICK':'[LOST] 베어브릭 주인 찾는 중'}</h1>
                    <ul className='cardLst'>
                        <li className='card cardL1'>
                          <img src={`${process.env.PUBLIC_URL + '/images/content/mbti/main/cardL1.png'}`} alt={`cardL1`} className='cardCtnt'/>
                        </li>
                        <li className='card cardL2'>
                          <img src={`${process.env.PUBLIC_URL + '/images/content/mbti/main/cardL2.png'}`} alt={`cardL2`} className='cardCtnt'/>
                        </li>
                        <li className='card mainCard'>
                          <div className='mainCardBg'/>
                            <div className='mainCardInfo'>
                                <h1 className="mt-5">
                                    {lang === 'en' ? (
                                        <>Choose now,<br />Don't let it slip away!</>
                                    ) : lang === 'zh' ? (
                                        <>立即選擇，別錯過!</>
                                    ) : (
                                        <>지금 선택 안 하면<br />날 놓칠 수도 있어!</>
                                    )}
                                </h1>
                                <div className='thumnailSlide'>
                                <ul>
                                    <li>
                                    <img
                                         src={`${process.env.PUBLIC_URL + '/images/content/mbti/thumnail/thumnail' + String(thumbIndex).padStart(2,'0') + '.png'}`}
                                        alt={`thumbnail ${thumbIndex}`}
                                    />
                                    </li>
                                </ul>
                                </div>
                                <button className="mbtibtn btn-primary mt-4" onClick={handleStart} aria-label={lang === 'en' ? 'Start Quiz' : lang === 'zh' ? '開始測驗' : '퀴즈 시작'}>
                                    <p>{lang === 'en'? 'Find My BE@RBRICK' : lang === 'zh' ? '找到我的 BE@RBRICK' : '내 베어브릭은?'}</p>
                                </button>
                            </div>
                        </li>
                        <li className='card cardR2'>
                          <img src={`${process.env.PUBLIC_URL + '/images/content/mbti/main/cardR2.png'}`} alt={`cardR2`} className='cardCtnt'/>
                        </li>
                        <li className='card cardR1'>
                          <img src={`${process.env.PUBLIC_URL + '/images/content/mbti/main/cardR1.png'}`} alt={`cardR1`} className='cardCtnt'/>
                        </li>
                    </ul>
                </article>
            )}

            {started && !showResult && !showWaiting && (
              <article className="question">
                <div className='mbtiCard'>
                  <div className='mbtilogoImgWrap'>
                    <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/logo.png'} alt="" className='mbtilogoImg'/> 
                  </div>
                  <div className='mbtiCardFrame questionFrame'>
                    <div className='qarea'>
                      <img src={currentQuestions[index].img} alt={currentQuestions[index].title} className='qImg'/>

                    </div>
                    <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/Vector22.png'} alt="" className='frameRT'/>
                    <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/Vector20.png'} alt="" className='frameLT'/>
                  </div>
                  <div className="choiceBtnWrap">
                      <button className="btn btn-primary w-75" onClick={() => handleAnswer('A')} aria-label={lang === 'en' || lang === 'zh' ? 'Choice A' : '선택 A'}>
                        <p>{currentQuestions[index].A}</p>
                      </button>
                      <button className="btn btn-outline-primary w-75" onClick={() => handleAnswer('B')} aria-label={lang === 'en' || lang === 'zh' ? 'Choice B' : '선택 B'}>
                        <p>{currentQuestions[index].B}</p>
                      </button>
                  </div>
                </div>
                </article>
            )}

            {showWaiting && (
                <article className="waiting text-center">
                  <div className='mbtiCard'>
                    <div className='mbtilogoImgWrap'>
                      <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/logo.png'} alt="" className='mbtilogoImg'/> 
                    </div>
                    <div className='' style={{position:"relative"}}>
                      <img src={process.env.PUBLIC_URL + '/images/content/mbti/waiting/card_l.png'} alt={lang === 'en' || lang === 'zh' ? 'Waiting image' : '대기 중 이미지'} className='watingBg'/>
                      <div className='waitingContent text-center'>
                        <h2 style={{textAlign:"center"}}>{lang === 'en' ? 'Finding My \nBE@RBRICK' : lang === 'zh' ? '正在尋找我的 BE@RBRICK' : '내 베어브릭 찾는 중'}{ellipsis}</h2>
                        {/* styles moved to Assets/css/mbti.css */}
                        <div className='thumnailSlide'>
                          <ul>
                              <li>
                              <img
                                  src={`${process.env.PUBLIC_URL + '/images/content/mbti/waiting/thumnail' + String(thumbIndex).padStart(2,'0') + '.png'}`}
                                  alt={`thumbnail ${thumbIndex}`}
                              />
                              </li>
                          </ul>
                        </div>
                        <div className='progressBar'>
                          {Array.from({ length: 30 }).map((_, i) => (
                            <div
                              key={i}
                              className={`progressfill ${showWaiting ? 'animate' : ''}`}
                              style={{ animationDelay: `${Math.round((2000 / 30) * i)}ms` }}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
            )}

            {showResult && (
                <article className="result text-center">
                  <div className='mbtiCard'>
                    <div className='mbtilogoImgWrap'>
                      <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/logo.png'} alt="" className='mbtilogoImg'/> 
                    </div>
                    <div className='mbtiCardFrame'>
                      <img src={currentResults[computeMbti()]?.card || '/images/placeholder.png'} alt={currentResults[computeMbti()]?.animal || (lang === 'en' ? 'Recommended Game' : '추천 게임')} className="img-fluid rounded rimg"/>
                      <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/Vector22.png'} alt="" className='frameRT'/>
                      <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/Vector20.png'} alt="" className='frameLT'/>
                      <button onClick={handleShare} aria-label={lang === 'en' || lang === 'zh' ? 'Copy Result URL' : '결과 URL 복사'} className='absoluteBtn'>
                        {lang === 'en' || lang === 'zh'? 
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/shareBtn_en.png'} alt={lang === 'en' ? 'Share' : '공유하기'} />
                          :
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/shareBtn02.png'} alt='공유하기'/>
                        }
                        </button>
                    </div>
                    <div className='choiceBtnWrap'>
                      {lang === 'en' ? 
                        <a href="https://forms.gle/YBN7WyborLUu2KRMA" target="_blank" rel="noopener noreferrer">
                          <p>Get Your BE@RBRICK</p>
                        </a>
                        :
                        <>
                        {lang === 'zh'?
                          <a href="https://forms.gle/KaE7NaPodf19soQ29" target="_blank" rel="noopener noreferrer">
                            <p>Get Your BE@RBRICK</p>
                          </a>
                        :
                         <Link
                          to={{ pathname: '/preregister', search: '?gameSvcCd=BBO', hash: '#formSec' }}
                          onClick={() => {
                            try {
                              playButtonSound("click");
                              const key = computeMbti();
                              const rn = currentResults[key]?.resultNumber || key;
                              gtmPush('bb4meGoPreregister', { result: key, resultNumber: rn });
                            } catch (e) {
                              // ignore
                            }
                          }}
                        >
                          <p>베어브릭 받으러가기</p>
                        </Link>
                        }
                        </>
                      }
                    </div>
                    {lang === 'en' || lang === 'zh'? 
                    <div className="restartBtnWrap">
                        <button onClick={handleShare} aria-label='Share' className='imgBtn' >
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/shareBtn.png'} alt='Share' />
                        </button>
                        <button onClick={handleDiscord} aria-label='Discord' className='imgBtn'>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/discordBtn.png'} alt='Discord' />
                        </button>
                        <button onClick={handleDownload} aria-label='Download Result Image' className='imgBtn'>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/downloadBtn.png'} alt='Download' />
                        </button>
                        <button className="restartBtn btn-secondary me-2" onClick={handleRestart}>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/restartIcon.png'} alt='Retake Test' />
                          <p>Redo Test</p>
                        </button>
                    </div>
                    :
                    <div className="restartBtnWrap">
                        <button onClick={handleCafe} aria-label='네이버 카페' className='moNone'>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/nvrCafeBtn.png'} alt='네이버 카페' />
                        </button>
                        <button onClick={handleShare} aria-label='공유하기' className='moBlock'>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/shareBtn02.png'} alt='공유하기' />
                        </button>
                        <button onClick={handleDownload} aria-label='결과 이미지 다운로드'>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/downloadBtn.png'} alt='다운로드하기' />
                        </button>
                        <button className="restartBtn btn-secondary me-2" onClick={handleRestart}>
                          <img src={process.env.PUBLIC_URL + '/images/content/mbti/main/restartIcon.png'} alt='테스트 다시하기' />
                          <p>테스트 다시하기</p>
                        </button>
                    </div>
                    }
                  </div>
                </article>
            )}
            {/* Audio for button feedback */}
            <audio ref={(el) => { soundRefs.current.complete = el; }} preload="auto" style={{ display: 'none' }}>
              <source src={process.env.PUBLIC_URL + '/audio/ui_complete.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.dragClick = el; }} preload="auto" style={{ display: 'none' }}>
              <source src={process.env.PUBLIC_URL + '/audio/ui_drag_click.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.click = el; }} preload="auto" style={{ display: 'none' }}>
              <source src={process.env.PUBLIC_URL + '/audio/ui_click.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.rightMenuSelect = el; }} preload="auto" style={{ display: 'none' }}>
              <source src={process.env.PUBLIC_URL + '/audio/ui_right_menu_select.wav'} type="audio/wav" />
            </audio>
            <audio ref={(el) => { soundRefs.current.bearbrickSearch = el; }} preload="auto" style={{ display: 'none' }}>
              <source src={process.env.PUBLIC_URL + '/audio/ui_bearbrick_search.wav'} type="audio/wav" />
            </audio>
    </div>
  );
}
